import {
  LinearProgress as MuiLinearProgress,
  withStyles,
} from "@material-ui/core";
import { COLORS } from "../../theme/colors";

export const LinearProgress = ({ active, value, variant }) => {
  const Component = withStyles((theme) => ({
    root: {
      height: 8,
      borderRadius: 4,
    },
    colorPrimary: {
      backgroundColor: "#F8F8F8",
    },
    bar: {
      borderRadius: 4,
      backgroundColor: active
        ? theme.palette.primary.main
        : COLORS.darks[0][100],
    },
  }))(MuiLinearProgress);
  return <Component value={value} variant={variant} />;
};
